/* ------------------------------------------------------------------------------
@name: Section1
@description: Section1
--------------------------------------------------------------------------------- */

const Section1 = (() => {
  // - handleSection1
  const handleSection1 = () => {
    var section_1 = new ScrollMagic.Controller({
      globalSceneOptions: { triggerHook: "onEnter", duration: "200%" },
    });

    // build scenes
    new ScrollMagic.Scene({ triggerElement: "#section_1" })
      .setTween(".section_1_bg", { y: "40%", ease: Linear.easeNone })
      .addTo(section_1);
  };

  // - init
  const init = () => {
    handleSection1();
  };

  return {
    init,
  };
})();

export default Section1;
